export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  imageUrl: string;
}

export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'wanfa-jiexi',
    name: '玩法解析',
    description: '全面解析六合彩各类玩法规则与投注方式，从基础入门到高级策略，帮助玩家快速掌握游戏要领。',
    icon: 'ri-book-open-line',
    articleCount: 24,
  },
  {
    id: 'cat-2',
    slug: 'lishi-shuju',
    name: '历史数据',
    description: '收录历年完整开奖记录与数据统计，提供多维度数据分析工具，助力科学决策。',
    icon: 'ri-bar-chart-line',
    articleCount: 36,
  },
  {
    id: 'cat-3',
    slug: 'haoma-zoushi',
    name: '号码走势',
    description: '可视化号码走势图表与冷热号分析，直观呈现号码分布规律与变化趋势。',
    icon: 'ri-line-chart-line',
    articleCount: 28,
  },
  {
    id: 'cat-4',
    slug: 'guize-daiquan',
    name: '规则大全',
    description: '完整收录六合彩官方规则条款、奖项设置与兑奖流程，确保玩家清晰了解各项规定。',
    icon: 'ri-file-text-line',
    articleCount: 18,
  },
  {
    id: 'cat-5',
    slug: 'tuku-cankao',
    name: '图库参考',
    description: '丰富的图库资源与参考素材，涵盖历史图表、走势图谱与统计分析可视化内容。',
    icon: 'ri-image-line',
    articleCount: 15,
  },
  {
    id: 'cat-6',
    slug: 'kaijiang-jilu',
    name: '开奖记录',
    description: '最新开奖结果实时更新，历史开奖记录完整存档，支持按日期与期数快速查询。',
    icon: 'ri-record-circle-line',
    articleCount: 52,
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'liuhe-jiben-wanfa-rumen',
    title: '六合彩基本玩法入门：新手必读完整指南',
    excerpt: '本文为新手玩家详细讲解六合彩的基本玩法规则，包括选号方式、投注类型、赔率计算等核心知识点，帮助您快速上手。',
    content: `<h2>六合彩简介</h2>
<p>六合彩是一种广受欢迎的数字彩票游戏，由香港马会奖券有限公司主办。每期从1至49的号码中搅珠抽出6个"正选号码"及1个"特别号码"，共7个中奖号码。</p>
<h2>基本玩法</h2>
<p>玩家需要从1至49号中选择6个号码作为一注。每注最低投注金额为港币10元。开奖时，若玩家选择的号码与开出的号码相符，即可获得相应奖金。</p>
<h2>主要投注方式</h2>
<ul>
<li><strong>单式投注</strong>：选择6个号码，这是最基本的投注方式。</li>
<li><strong>复式投注</strong>：选择7个或以上号码，系统会自动组合所有可能的6个号码组合。</li>
<li><strong>胆拖投注</strong>：选择1至5个"胆码"（必选号码），再选择多个"拖码"，组合成多注。</li>
</ul>
<h2>奖项等级</h2>
<p>六合彩共设7个奖项等级：</p>
<ul>
<li><strong>头奖</strong>：选中6个正选号码</li>
<li><strong>二奖</strong>：选中5个正选号码 + 特别号码</li>
<li><strong>三奖</strong>：选中5个正选号码</li>
<li><strong>四奖</strong>：选中4个正选号码 + 特别号码</li>
<li><strong>五奖</strong>：选中4个正选号码</li>
<li><strong>六奖</strong>：选中3个正选号码 + 特别号码</li>
<li><strong>七奖</strong>：选中3个正选号码</li>
</ul>
<h2>投注技巧建议</h2>
<p>对于新入门的玩家，建议从单式投注开始，熟悉规则后再尝试复式或胆拖投注。合理分配投注预算，切勿沉迷，保持理性娱乐的心态。通过长期观察历史数据与号码走势，可以逐步形成自己的选号策略。</p>`,
    category: '玩法解析',
    categorySlug: 'wanfa-jiexi',
    author: '六合宝典编辑部',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    tags: ['新手入门', '基本玩法', '投注方式'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20lottery%20balls%20with%20numbers%20on%20a%20rich%20red%20velvet%20surface%2C%20golden%20accents%2C%20warm%20ambient%20lighting%2C%20elegant%20minimalist%20composition%2C%20soft%20shadows%2C%20professional%20product%20photography%2C%20clean%20background%20with%20subtle%20texture&width=800&height=450&seq=article-basic-01&orientation=landscape',
  },
  {
    id: 'article-2',
    slug: 'fushi-touzhu-gaoji-jiqiao',
    title: '复式投注高级技巧：提高中奖概率的科学方法',
    excerpt: '深入分析复式投注的数学原理与策略优化，通过概率论角度解读如何合理配置号码组合，最大化回报率。',
    content: `<h2>复式投注的数学基础</h2>
<p>复式投注是指选择超过6个号码进行投注，系统会自动生成所有可能的6个号码组合。例如选择7个号码，则会生成7注不同的单式组合。</p>
<h2>成本与覆盖分析</h2>
<p>选择n个号码进行复式投注时，投注注数为C(n,6)。以下为常见选择对应的注数：</p>
<ul>
<li>7个号码：7注（70元）</li>
<li>8个号码：28注（280元）</li>
<li>9个号码：84注（840元）</li>
<li>10个号码：210注（2,100元）</li>
</ul>
<h2>策略优化建议</h2>
<p>复式投注虽能增加中奖概率，但成本也呈几何级增长。建议根据自身预算合理选择复式规模。对于中等预算玩家，7-9个号码的复式投注是最佳平衡点。</p>
<h2>号码选择策略</h2>
<p>在进行复式投注时，号码分布至关重要。建议覆盖不同区间（1-16, 17-33, 34-49），避免号码过度集中。同时参考冷热号数据，平衡选择热门号码与冷门号码，以优化整体组合质量。</p>`,
    category: '玩法解析',
    categorySlug: 'wanfa-jiexi',
    author: '六合宝典编辑部',
    publishDate: '2026-08-03',
    readTime: '10分钟',
    tags: ['复式投注', '投注策略', '概率分析'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20lottery%20balls%20arranged%20in%20a%20geometric%20pattern%20on%20dark%20wood%20surface%2C%20warm%20golden%20light%2C%20mathematical%20diagrams%20subtly%20visible%2C%20professional%20editorial%20photography%2C%20elegant%20and%20sophisticated%20aesthetic&width=800&height=450&seq=article-advanced-02&orientation=landscape',
  },
  {
    id: 'article-3',
    slug: 'shuju-fenxi-yuce-moxing',
    title: '历史数据分析：基于统计学的号码预测模型',
    excerpt: '利用统计学方法对历年开奖数据进行深度挖掘，建立号码出现频率、间隔分布等多维度分析模型。',
    content: `<h2>数据分析方法论</h2>
<p>通过对近十年超过1500期的六合彩开奖数据进行统计分析，我们可以发现一些有趣的规律和趋势。虽然彩票本质上是一个随机过程，但统计分析可以帮助我们做出更理性的选择。</p>
<h2>频率分析</h2>
<p>在49个号码中，每个号码在长期来看出现的概率应该是均等的。但短期内会存在一定的波动。通过分析最近100期、200期、500期的数据，可以识别出当前处于"热态"和"冷态"的号码。</p>
<h2>间隔分析</h2>
<p>间隔分析考察的是每个号码两次出现之间的期数间隔。通过间隔分布模型，可以估算某个号码"应该"再次出现的概率区间。</p>
<h2>组合关联分析</h2>
<p>某些号码之间存在一定的"联动"趋势。通过关联规则挖掘，可以识别出历史数据中高频共现的号码组合，为投注提供参考依据。</p>
<p>需要注意的是，所有分析结果仅供参考，彩票开奖具有随机性，过往数据不能保证未来结果。</p>`,
    category: '历史数据',
    categorySlug: 'lishi-shuju',
    author: '六合宝典编辑部',
    publishDate: '2026-08-02',
    readTime: '12分钟',
    tags: ['数据分析', '预测模型', '统计分析'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Statistical%20charts%20and%20data%20visualization%20with%20warm%20red%20and%20gold%20color%20scheme%2C%20analytics%20dashboard%20aesthetic%2C%20clean%20modern%20design%2C%20professional%20data%20science%20visualization%2C%20soft%20ambient%20lighting&width=800&height=450&seq=article-data-03&orientation=landscape',
  },
  {
    id: 'article-4',
    slug: 'zoushi-tu-fenxi-zhinan',
    title: '号码走势图分析指南：读懂图表背后的信息',
    excerpt: '手把手教会您如何阅读和分析六合彩号码走势图，掌握图表中的关键指标和隐藏信息。',
    content: `<h2>走势图的基本构成</h2>
<p>号码走势图是六合彩分析中最常用的工具之一。它以直观的图表形式展示每个号码在不同期数中的出现情况，帮助玩家快速把握号码的整体走势。</p>
<h2>冷热号识别</h2>
<p>走势图中最直观的信息就是冷热号分布。处于上升趋势、频繁出现的号码称为"热号"；长时间未出现的号码称为"冷号"。通过走势图可以一目了然地识别当前各号码的冷热状态。</p>
<h2>遗漏值分析</h2>
<p>遗漏值是指某个号码自上次出现以来经过的期数。走势图中可以清晰看到每个号码的遗漏情况。当某个号码的遗漏值达到历史高位时，需特别关注。</p>
<h2>区间分布趋势</h2>
<p>将1-49号分为若干区间（如1-10, 11-20, 21-30, 31-40, 41-49），观察每期开奖号码在各区间的分布情况。通过区间热力分析，可以发现某些区间在特定时期的活跃程度。</p>`,
    category: '号码走势',
    categorySlug: 'haoma-zoushi',
    author: '六合宝典编辑部',
    publishDate: '2026-08-04',
    readTime: '9分钟',
    tags: ['走势图', '冷热号', '图表分析'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Line%20chart%20and%20data%20visualization%20showing%20trends%20with%20warm%20amber%20and%20crimson%20highlights%2C%20minimalist%20dashboard%20design%2C%20clean%20white%20background%20with%20subtle%20grid%20lines%2C%20professional%20financial%20data%20aesthetic&width=800&height=450&seq=article-chart-04&orientation=landscape',
  },
  {
    id: 'article-5',
    slug: 'jiangxiang-shezhi-xiangjie',
    title: '奖项设置详解：各等级奖金分配与领取流程',
    excerpt: '详细说明六合彩七个奖项等级的奖金分配规则、中奖条件以及奖金领取的完整流程。',
    content: `<h2>奖项等级总览</h2>
<p>六合彩共设七个奖项等级，从选中3个正选号码的七等奖，到选中全部6个正选号码的头等奖，奖金依次递增。</p>
<h2>奖金分配机制</h2>
<p>每期六合彩的总投注额中，54%用作奖金基金。其中头奖奖金基金占奖金基金的45%，二奖占15%，三奖占40%（具体比例可能根据规则调整）。</p>
<h2>领奖流程</h2>
<p>中奖者需在开奖日起60天内领取奖金。头奖及二奖中奖者须致电马会奖券有限公司登记，其他奖项可于各场外投注处领取。</p>
<h2>注意事项</h2>
<p>请妥善保管中奖彩票，彩票为不记名票据，任何人持有中奖彩票均可领取奖金。如彩票有任何损毁或涂改，可能会影响领奖资格。</p>`,
    category: '规则大全',
    categorySlug: 'guize-daiquan',
    author: '六合宝典编辑部',
    publishDate: '2026-08-05',
    readTime: '7分钟',
    tags: ['奖项设置', '奖金分配', '领奖流程'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20trophy%20and%20award%20certificate%20on%20elegant%20dark%20wood%20desk%2C%20warm%20luxurious%20lighting%2C%20premium%20atmosphere%2C%20professional%20photography%2C%20clean%20composition%20with%20rich%20textures&width=800&height=450&seq=article-prize-05&orientation=landscape',
  },
  {
    id: 'article-6',
    slug: 'tupian-cankao-tujie',
    title: '图片参考图解：走势图谱与统计可视化素材库',
    excerpt: '汇总整理各类六合彩分析相关的图表、图解与可视化素材，为玩家提供丰富的参考资源。',
    content: `<h2>图库资源分类</h2>
<p>我们的图库涵盖了多种类型的图表资源：</p>
<ul>
<li>历史走势图谱：展示各号码长期走势</li>
<li>冷热分布图：直观呈现号码冷热状态</li>
<li>区间分析图：各区间号码分布情况</li>
<li>遗漏统计图：号码遗漏值可视化</li>
<li>综合对比图：多维度数据综合展示</li>
</ul>
<h2>如何使用图库</h2>
<p>所有图表均可在线查看和参考。建议结合文字分析内容，配合图表加深理解。图表定期更新，确保数据的时效性。</p>`,
    category: '图库参考',
    categorySlug: 'tuku-cankao',
    author: '六合宝典编辑部',
    publishDate: '2026-08-06',
    readTime: '6分钟',
    tags: ['图库', '可视化', '参考素材'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Gallery%20wall%20displaying%20various%20charts%20and%20data%20visualizations%20in%20warm%20red%20and%20gold%20tones%2C%20modern%20gallery%20setting%20with%20track%20lighting%2C%20professional%20exhibition%20photography%2C%20clean%20minimalist%20frames&width=800&height=450&seq=article-gallery-06&orientation=landscape',
  },
  {
    id: 'article-7',
    slug: 'zuixin-kaijiang-jieguo',
    title: '最新开奖结果：2026年第XXX期号码详情与分析',
    excerpt: '第一时间为您带来最新一期六合彩开奖结果，包括中奖号码、奖金分配及本期号码特征分析。',
    content: `<h2>本期开奖详情</h2>
<p>2026年第XXX期六合彩已于近期开奖。本期正选号码为：02、15、23、34、41、48，特别号码为：07。</p>
<h2>号码特征分析</h2>
<p>本期开奖号码呈现以下特征：奇数3个（15、23、41），偶数3个（02、34、48），奇偶比例均衡。号码分布覆盖四个区间，大小号码分布均匀。</p>
<h2>奖金情况</h2>
<p>本期头奖奖金为港币XXX万元，共有X注中奖。二奖每注派彩港币XXX万元。</p>`,
    category: '开奖记录',
    categorySlug: 'kaijiang-jilu',
    author: '六合宝典编辑部',
    publishDate: '2026-08-07',
    readTime: '5分钟',
    tags: ['开奖结果', '最新开奖', '号码分析'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Lottery%20drawing%20machine%20with%20numbered%20balls%20in%20motion%2C%20dramatic%20lighting%2C%20warm%20red%20and%20gold%20color%20palette%2C%20professional%20studio%20photography%2C%20clean%20background%2C%20sense%20of%20excitement%20and%20anticipation&width=800&height=450&seq=article-result-07&orientation=landscape',
  },
  {
    id: 'article-8',
    slug: 'leng-re-hao-fenxi-fangfa',
    title: '冷热号分析方法：从数据中发现选号规律',
    excerpt: '系统讲解冷热号的概念、计算方法与分析技巧，帮助玩家建立科学的号码评估体系。',
    content: `<h2>什么是冷热号</h2>
<p>冷热号是基于历史数据对号码活跃程度的分类。热号指在近期开奖中频繁出现的号码，冷号指长期未出现的号码。</p>
<h2>冷热号判定标准</h2>
<p>通常以最近30期、50期、100期为观察窗口，计算每个号码的出现频率。出现频率显著高于理论值的为热号，显著低于理论值的为冷号。</p>
<h2>实战应用策略</h2>
<p>不同玩家对冷热号有不同的使用偏好。部分玩家倾向追随热号趋势，也有玩家喜欢赌冷号回补。建议结合自身风格，灵活运用冷热号数据作为参考。</p>`,
    category: '号码走势',
    categorySlug: 'haoma-zoushi',
    author: '六合宝典编辑部',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    tags: ['冷热号', '选号技巧', '数据分析'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Thermal%20imaging%20style%20visualization%20of%20numbers%20with%20warm%20red%20and%20cool%20blue%20gradients%2C%20data%20analytics%20aesthetic%2C%20modern%20clean%20design%2C%20professional%20scientific%20visualization&width=800&height=450&seq=article-hotcold-08&orientation=landscape',
  },
  {
    id: 'article-9',
    slug: 'touzhu-yusuan-guanli',
    title: '投注预算管理：理性娱乐的资金分配原则',
    excerpt: '帮助玩家建立健康的投注预算管理体系，提供实用的资金分配策略与风险控制方法。',
    content: `<h2>预算管理的重要性</h2>
<p>理性参与六合彩的基础是建立科学的预算管理体系。合理的资金规划不仅能够延长参与时间，也能避免因过度投注带来的财务压力。</p>
<h2>预算制定原则</h2>
<p>建议将每月用于六合彩的支出控制在可支配收入的1%-3%以内。这笔支出应被视为娱乐消费，而非投资行为。</p>
<h2>资金分配策略</h2>
<p>可以将月度预算分为几个部分：基础投注（单式为主）、策略投注（复式或胆拖）、保留资金（用于特别时机）。</p>
<h2>风险警示</h2>
<p>彩票游戏具有随机性，不存在必胜策略。请始终保持理性心态，切勿沉迷。如发现自身有赌博倾向，请及时寻求专业帮助。</p>`,
    category: '玩法解析',
    categorySlug: 'wanfa-jiexi',
    author: '六合宝典编辑部',
    publishDate: '2026-07-25',
    readTime: '7分钟',
    tags: ['预算管理', '理性投注', '资金规划'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20with%20financial%20planning%20documents%20and%20calculator%2C%20warm%20natural%20light%2C%20organized%20workspace%2C%20professional%20photography%2C%20golden%20accents%20on%20stationery&width=800&height=450&seq=article-budget-09&orientation=landscape',
  },
];

export const featuredArticles = articles.slice(0, 4);

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};